module.exports = __webpack_public_path__ + "static/media/tv.7d9ae393.svg";